// extracted by mini-css-extract-plugin
module.exports = {"Container":"Sponsor_Container__MqlME","Label":"Sponsor_Label__Sa6F3","Logo":"Sponsor_Logo__bI6OG"};